'use client';

import { c as _c } from "react/compiler-runtime";
import { type Rule } from '@shared/all/domains/spaces';
import useUser from '@shared/utils/hooks/useUser';
import { useState } from 'react';
import Button from '../common/Button';
import EditRules from './EditRules';
import RuleItem from './RuleItem';
type FactiiiRulesData = {
  rules: Rule[];
  owner: {
    id: number;
    username: string;
  };
  id: number;
};
type SpaceRulesData = {
  rules: Rule[];
  spaceSlug?: string;
  membership?: {
    roles: string[];
  };
};
type Props = {
  space?: SpaceRulesData;
  factiii?: FactiiiRulesData;
  addRule: (rule: Rule) => void;
  editRule: (rule: Rule) => void;
};
const Rules = props => {
  const $ = _c(31);
  const {
    currentUser
  } = useUser();
  const {
    space,
    factiii
  } = props;
  const [modifyRulesModalOpen, setModifyRulesModalOpen] = useState(null);
  const isFactiii = Boolean(factiii);
  const rulesData = factiii || space;
  let canEdit;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== currentUser || $[1] !== factiii || $[2] !== isFactiii || $[3] !== rulesData?.rules || $[4] !== space) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const rules = rulesData?.rules || [];
      let t4;
      if ($[10] !== currentUser || $[11] !== factiii?.owner || $[12] !== isFactiii || $[13] !== space) {
        t4 = isFactiii ? Boolean(factiii?.owner) && Boolean(currentUser.isAuthenticated) && currentUser.username === factiii?.owner?.username : space?.membership ? space.membership.roles.includes("OWNER") : false;
        $[10] = currentUser;
        $[11] = factiii?.owner;
        $[12] = isFactiii;
        $[13] = space;
        $[14] = t4;
      } else {
        t4 = $[14];
      }
      canEdit = t4;
      const emptyMessage = isFactiii ? "This factiii has no special rules." : "This space has no special rules.";
      if (!space && !factiii) {
        let t5;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <div>No data provided</div>;
          $[15] = t5;
        } else {
          t5 = $[15];
        }
        t3 = t5;
        break bb0;
      }
      if ($[16] !== canEdit) {
        t0 = canEdit && <Button text="New Rule" onClick={() => setModifyRulesModalOpen("new")} classNames="block ml-auto mt-3 mr-2" />;
        $[16] = canEdit;
        $[17] = t0;
      } else {
        t0 = $[17];
      }
      t1 = rules.length === 0 && <p className="mb-2 ml-4 text-textSecondary/60">{emptyMessage}</p>;
      t2 = rules.length > 0 && <div className="mt-2 space-y-2">{rules.sort(_temp).map((rule, index) => <RuleItem key={rule.id} {...rule} id={rule.id} index={index} editClickHandler={() => setModifyRulesModalOpen(rule.id)} isOwner={canEdit} />)}</div>;
    }
    $[0] = currentUser;
    $[1] = factiii;
    $[2] = isFactiii;
    $[3] = rulesData?.rules;
    $[4] = space;
    $[5] = canEdit;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    canEdit = $[5];
    t0 = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[18] !== canEdit || $[19] !== factiii?.id || $[20] !== modifyRulesModalOpen || $[21] !== props.addRule || $[22] !== props.editRule || $[23] !== rulesData?.rules || $[24] !== space?.spaceSlug) {
    t4 = canEdit && modifyRulesModalOpen !== null && <EditRules spaceSlug={space?.spaceSlug} factiiiId={factiii?.id} addRule={props.addRule} editRule={props.editRule} type={modifyRulesModalOpen} closeHandler={() => setModifyRulesModalOpen(null)} rule={modifyRulesModalOpen !== "new" ? rulesData?.rules?.find(x => x.id === modifyRulesModalOpen) : undefined} />;
    $[18] = canEdit;
    $[19] = factiii?.id;
    $[20] = modifyRulesModalOpen;
    $[21] = props.addRule;
    $[22] = props.editRule;
    $[23] = rulesData?.rules;
    $[24] = space?.spaceSlug;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  let t5;
  if ($[26] !== t0 || $[27] !== t1 || $[28] !== t2 || $[29] !== t4) {
    t5 = <>{t0}{t1}{t2}{t4}</>;
    $[26] = t0;
    $[27] = t1;
    $[28] = t2;
    $[29] = t4;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  return t5;
};
export default Rules;
function _temp(a, b) {
  return a.id - b.id;
}